import React, { useMemo } from "react";
import { selectCommittedEntities } from "state/selections/selector";
import { useSelector } from "react-redux";
import Mode from "state/selections/Mode";
import styled from "styled-components";
import { useFormat } from "@ls/js-utils/date-fns";

const Root = styled.div`
  color: #fff;
  font-size: 1em;
  position: relative;
  display: flex;
  flex-direction: column;
`;
const TitleText = styled.div`
  text-align: center;
`;
const AsOfDate = styled.div`
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 0.9em;
  color: #ffffff;
  background: rgb(0 0 0 / 25%);
  margin-left: auto;
`;
const AsOfDateText = styled.span``;
const SymbolicDate = styled.span`
  margin: 0 0 0 5px;
  color: #e4d995;
`;
const MainTitle = () => {
  const {
    groupTypeEntity,
    groupEntities,
    modeEntity,
    scenarioEntity,
    asOfDateEntity,
    symbolicDate,
  } = useSelector(selectCommittedEntities);
  const format = useFormat();
  const asOfDateFormatted = useMemo(() => {
    if (asOfDateEntity) {
      return format(asOfDateEntity, "P");
    }
  }, [asOfDateEntity, format]);

  const mainTitleText = useMemo(() => {
    switch (modeEntity.value) {
      case Mode.ACC_GROUPS: {
        return (
          groupTypeEntity &&
          (groupEntities
            ?.map(
              (groupEntity) =>
                groupEntity[groupTypeEntity.comboboxLabelKey] || groupEntity.id
            )
            ?.join(", ") ??
            "...")
        );
      }
      case Mode.SCENARIOS:
        return scenarioEntity?.label;
      case Mode.ENTITIES:
        return "Custom Entity Group";
      default:
        console.error("unknown mode", modeEntity);
    }
  }, [groupTypeEntity, groupEntities, modeEntity, scenarioEntity]);
  return (
    <Root>
      <TitleText>{mainTitleText}</TitleText>
      {asOfDateFormatted && (
        <AsOfDate>
          As of <AsOfDateText>{asOfDateFormatted}</AsOfDateText>
          {symbolicDate && <SymbolicDate>({symbolicDate})</SymbolicDate>}
        </AsOfDate>
      )}
    </Root>
  );
};
export default MainTitle;
